import React, { useState } from 'react'
import { IconButton, ListItem, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
const EditItem = ({ id, word, removeItem, setOpen, setMessage, stateList, index }) => {
    const [value, setValue] = useState(word)
    const handleRemoveClick = () => {
        removeItem(word, id);
    }
    
  return (
    
    <ListItem className='card' key={id} style={{justifyContent:'center',width:'auto'}}>zw
      <TextField
        rows={1}
        value={stateList[index]}
        onChange={ (e) => {
            if (e.target.value.includes(',')){
                setOpen(true)
                setMessage('You cannot enter comma (,)')
            }
            else {
                setValue(e.target.value)
                stateList[index] = e.target.value
            }
        }}
        variant='outlined'
        />
      < IconButton onClick={handleRemoveClick}>
        <CloseIcon />
      </IconButton>
    </ListItem>
  );
}

export default EditItem
